import http from "@/services/http";
import httpForm from "@/services/httpForm"

export const clientes = () => {
  async function list() {
    const {data} = await http.get('/client/list');
    return data;
  }

  async function store(itemFormData) {
    const response = await httpForm.post('/client/store', itemFormData);
    return response.data;
  }

  async function delet(id) {
    await http.put('/client/delete/'+id, {});
    return true;
  }

  async function update(itemFormData) {
    const response = await httpForm.post('/client/edit', itemFormData);
    return response.data;
  }

  async function getOne(id) {
    const {data} = await http.get('/client/getOne/'+id);
    return data;
  }

  return {list, store, delet, update,getOne};
}